import serverConfig from "config/server";

export const isLocalDev = () =>
  serverConfig.env === "local-dev" || serverConfig.env === "ci";
